<template>
  <span>
    <v-container
      v-if="!isLoading"
      class="main--text pb-0"
      fluid>
      <v-row
        justify=space-between
        align=center
        no-gutters>
        <v-col
          class="pb-0"
          cols=auto>
          <h2>オンラインエディタ</h2>
        </v-col>
        <v-col>
          <a href="https://reversi-prosense.firebaseapp.com/" target="_blank">
            <v-icon>mdi-gamepad-circle</v-icon>
          </a>
        </v-col>
        <v-col
          class="pb-0"
          cols=auto>
          <v-btn
            color=primary
            @click="toEditors"
            text>退室
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-container
      class="pt-0 pb-1"
      fluid>
      <v-row
        class="screen">
        <v-col
          cols=8>
          <v-shared-editor
            v-if="!isLoading"
          />
        </v-col>
        <v-col
          class="pl-0 pr-2"
          cols=4>
          <v-container
            class="pl-0 pr-0 pt-0 pb-0"
            fluid>
            <v-video-chat
              :room="roomId"
              :partnerId="partnerId"
            />
          </v-container>
        </v-col>
      </v-row>
    </v-container>

    <v-container
      v-if="!isLoading"
      class="main--text"
      fluid
      >
      <v-row
        justify=start
        dense>
        <v-col
          cols=auto>
          <v-btn
            fab
            right
            color="warning"
            top
            class="ml-4 mt-3"
            @click="run">
            <span class="font-weight-bold">Run</span>
          </v-btn>
        </v-col>
      </v-row>
      <v-row
        no-gutters>
        <v-col
          cols=9
          class="pl-4 pt-4">
          <v-card flat>
            <v-tabs
              v-model="selected"
              style="border-radius:0"
              dark
              hide-slider>
              <v-tab
                v-for="(tab, index) in tabs"
                :key="index"
                :href="`#tab-${index}`"
                style="margin:0"
                >
                <span class="font-weight-bold">{{tab}}</span>
              </v-tab>
              <v-tabs-items v-model="selected">
                <v-tab-item
                  value="tab-0">
                    <textarea v-model="stdin" class="stdin-form"></textarea>
                </v-tab-item>
                <v-tab-item
                  value="tab-1">
                    <textarea v-model="output" class="stdout-form" disabled></textarea>
                </v-tab-item>
              </v-tabs-items>
            </v-tabs>
          </v-card>
        </v-col>
      </v-row>
      <v-progress
        :value="inProgress"
      />
    </v-container>
  </span>
</template>

<script>
import { app } from '@/core/firebase'
import VSharedEditor from '@/components/organisms/editor/VSharedEditor'
import VVideoChat from '@/components/organisms/editor/VVideoChat'
import Loading from '@/components/organisms/Loading'
import VProgress from '@/components/organisms/VProgress'

export default {
  components: {
    VSharedEditor,
    VVideoChat,
    Loading,
    VProgress
  },
  props: {
    partnerId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      stdin: "",
      output: "",
      tabs: [
        '入力',
        '出力'
      ],
      firepad: null,
      selected: 'tab-0',
      isLoading: false,
      inProgress: false
    }
  },
  methods: {
    async run() {
      this.inProgress = true
      const text = this.firepad.getText()
      this.output = await this.executeNodejs(text)
      this.inProgress = false
      this.selected = 'tab-1'
    },
    async executePython(text) {
      const executeFunc = app.functions().httpsCallable('pythonTriggerFunction')
      const res = await executeFunc({ text, stdin: this.stdin})
      return res.data
    },
    async executeNodejs(text) {
      const executeFunc = app.functions().httpsCallable('nodejsTriggerFunction')
      const res = await executeFunc({ text, stdin: this.stdin})
      return res.data
    },
    toEditors() {
      if (this.$store.getters.isParent) {
        this.$router.push({ name: 'parentEditors', params: { id: this.$store.getters.parent.getId()}})
      } else if (this.$store.getters.teacher) {
        this.$router.push('/teacher/' + this.$store.getters.teacher.uuid + '/editors')
      }
    }
  },
  mounted: async function() {
    const firepadRef = app.database().ref('editor').child(this.roomId)
    const codeMirror = CodeMirror(document.getElementById('editor'), { lineWrapping: false, lineNumbers: true, mode: 'javascript', matchBrackets: true, autoCloseBrackets: true, indentUnit: 2 })
    codeMirror.setOption('extraKeys', {
      Tab: function(cm) {
        let spaces = Array(cm.getOption('indentUnit') + 1).join(' ')
        cm.replaceSelection(spaces)
      }
    })
    this.firepad = Firepad.fromCodeMirror(firepadRef, codeMirror,
      { richTextShortcuts: true, richTextToolbar: false, defaultText: 'console.log("Hello world.")' }
    )
  },
  computed: {
    roomId () {
      return (this.$store.getters.isParent) ? this.$route.params.id + this.partnerId : (this.$store.getters.isTeacher) ? this.partnerId + this.$route.params.id : 'defaultRoom'
    }
  }
}
</script>

<style scoped>
.stdin-form {
  color: white;
  background-color: black;
  width: 100%;
  height: 200px;
  white-space: pre-line;
  padding: 10px;
  letter-spacing: 1px;
}

.stdout-form {
  color: white;
  background-color: black;
  width: 100%;
  height: 200px;
  white-space: pre-line;
  padding: 10px;
  letter-spacing: 1px;
}

.screen {
  height: 100%;
}

.no--vertical--paddings {
  padding: 0px 12px;
}

</style>
